module.exports = __webpack_public_path__ + "img/Avatar-48.affb15d0.svg";